import { useRef } from "react";
import styled from "@emotion/styled/macro";
import { Drawer, DrawerContent, DrawerOverlay, Flex, useDisclosure, useTheme } from "@chakra-ui/react";
import SecondaryMenu from "../../ui/SecondaryMenu";
import VerticalMenu from "../VericalMenu";
import Menu from "../../ui/Menu";
import LanguageBox from "../../ui/LanguageBox";
import hamburger from "../../../assets/images/hamburger.svg";
import closeIcon from "../../../assets/images/close.svg";
import { ContentLayout } from "../../ui/ContentLayout";
import Logo from "./Logo";
const Wrapper = styled(Flex)`
  color: ${({ theme }) => theme.colors.primary};
  background-color: ${({ theme }) => theme.colors.white};
  height: 4em;
  align-items: center;
  justify-content: center;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    height: 100%;
    justify-content: flex-start;
    min-height: 4em;
  }
`;
const ToggleIconWrapper = styled.div`
  position: absolute;
  right: ${({ theme }) => theme.space["8"]};
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    display: none;
  }
`;
const StyledDrawerContent = styled(DrawerContent)`
  left: 20px;
  top: ${({ theme }) => theme.layout.header.height} !important;
`;
const StyledDrawerOverlay = styled(DrawerOverlay)`
  background: none;
`;

const ToggleIcon = styled.img`
  cursor: pointer;
`;

const MenuWrapper = styled.div`
  display: flex;
  flex: 1;
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    flex-direction: column;
    height: 100%;
    justify-content: space-around;
  }
  ul {
    display: none;
    @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
      display: flex;
    }
    list-style-type: none;
  }
`;

const SecondaryMenuWrapper = styled.div`
  display: none;
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    display: flex;
    align-self: flex-end;
  }
  ul {
    display: none;
    @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
      display: flex;
    }

    list-style-type: none;
  }
`;

const LanguageWrapper = styled.div`
  display: none;
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    display: flex;
    align-self: baseline;
  }
`;

const Container = styled(ContentLayout)`
  display: flex;
  flex-direction: column;
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    padding-top: 10px;
  }
`;
const Header = () => {
  const iconRef = useRef();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const theme = useTheme();
  return (
    <Container>
      <SecondaryMenuWrapper>
        <SecondaryMenu />
        <LanguageWrapper>
          <LanguageBox colorTheme={theme.colors.opal} />
        </LanguageWrapper>
      </SecondaryMenuWrapper>
      <Wrapper>
        <Logo />
        <ToggleIconWrapper>
          <ToggleIcon ref={iconRef} src={isOpen ? closeIcon : hamburger} onClick={isOpen ? onClose : onOpen} />
        </ToggleIconWrapper>

        <MenuWrapper>
          <Menu />
        </MenuWrapper>
        <Drawer isOpen={isOpen} placement="right" onClose={onClose} size={"full"}>
          <StyledDrawerOverlay>
            <StyledDrawerContent>
              <VerticalMenu onClose={onClose} />
            </StyledDrawerContent>
          </StyledDrawerOverlay>
        </Drawer>
      </Wrapper>
    </Container>
  );
};

export default Header;
